"use client";

import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { sans as zoram, fontSize32, fontSize42, lineHeightTight, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
import { jsx as _jsx } from "react/jsx-runtime";
export const internalUseOnlyPriority1 = css(["margin:0;font-family:", ";font-style:normal;font-weight:", ";font-size:", ";line-height:", ";letter-spacing:-0.03125rem;", ";"], zoram, fontWeightBold, fontSize32, lineHeightTight, props => props.small ? "" : mediaBreak600w`font-size: ${fontSize42};`);
const H1Styled = styled.h1.withConfig({
  componentId: "sc-1tfwysu-0"
})(["", ";"], internalUseOnlyPriority1);

/**
 * Used for most situations, including manuals, apps, and standard webpages. This is the default h1 style.
 */
const H1 = _ref => {
  let {
    small,
    children,
    renderAs,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(H1Styled, {
    small: small,
    as: renderAs,
    ...props,
    children: children
  });
};
export default H1;
H1.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired,
  /** Whether smaller styles should be applied */
  small: PropTypes.bool,
  /** The HTML tag string (e.g., `"div"`) or React component to render as. */
  renderAs: PropTypes.elementType
};